"use client";
import { cn as e } from "../../../lib/utils.es.js";
import { jsx as l, jsxs as s } from "react/jsx-runtime";
import { X as c } from "lucide-react";
import * as t from "@radix-ui/react-dialog";
var m = t.Root, g = t.Portal, f = ({ className: a, ...i }) => /* @__PURE__ */ l(t.Overlay, {
  className: e("lib:data-[state=closed]:fade-out-0 lib:data-[state=open]:fade-in-0 lib:fixed lib:inset-0 lib:z-50 lib:bg-black/80 lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in", a),
  "data-slot": "dialog-overlay",
  ...i
}), u = ({ className: a, ...i }) => /* @__PURE__ */ l(t.Title, {
  className: e("lib:font-semibold lib:text-lg lib:leading-none lib:tracking-tight", a),
  "data-slot": "dialog-title",
  ...i
}), p = ({ className: a, ...i }) => /* @__PURE__ */ l(t.Description, {
  className: e("lib:text-muted-foreground lib:text-sm", a),
  "data-slot": "dialog-description",
  ...i
}), h = ({ className: a, children: i, ...o }) => /* @__PURE__ */ s(g, { children: [/* @__PURE__ */ l(f, {}), /* @__PURE__ */ l(t.Content, {
  className: e("lib:data-[state=closed]:fade-out-0 lib:data-[state=open]:fade-in-0 lib:data-[state=closed]:zoom-out-95 lib:data-[state=open]:zoom-in-95 lib:fixed lib:top-[50%] lib:left-[50%] lib:z-50 lib:my-auto lib:flex lib:h-max lib:w-full lib:max-w-lg lib:translate-x-[-50%] lib:translate-y-[-50%] lib:flex-col lib:bg-background lib:p-6 lib:duration-200 lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in lib:sm:rounded-lg", a),
  "data-slot": "dialog-content",
  ...o,
  children: i
})] }), N = ({ open: a, onClose: i, children: o, title: n, customCloseButton: b, description: d, ...r }) => /* @__PURE__ */ l(m, {
  onOpenChange: i,
  open: a,
  children: /* @__PURE__ */ s(h, {
    ...r,
    children: [
      /* @__PURE__ */ l(u, {
        className: "lib:sr-only",
        children: n
      }),
      /* @__PURE__ */ l(p, {
        className: "lib:sr-only",
        children: d
      }),
      o,
      /* @__PURE__ */ l(t.Close, {
        asChild: !0,
        className: "lib:z-10",
        children: b || /* @__PURE__ */ s("button", {
          className: "lib:absolute lib:top-4 lib:right-4 lib:rounded-sm lib:text-black lib:opacity-70 lib:ring-offset-background lib:transition-opacity lib:hover:opacity-100 lib:focus:outline-hidden lib:focus:ring-2 lib:focus:ring-ring lib:focus:ring-offset-2 lib:disabled:pointer-events-none lib:data-[state=open]:bg-accent lib:data-[state=open]:text-muted-foreground",
          children: [/* @__PURE__ */ l(c, { className: "lib:h-4 lib:w-4" }), /* @__PURE__ */ l("span", {
            className: "lib:sr-only",
            children: "Закрыть"
          })]
        })
      })
    ]
  })
});
export {
  N as default
};
